import { ICoreContext } from "@msdyn365-commerce/core";
import { SimpleProduct } from "@msdyn365-commerce/retail-proxy";

const currencyFormatter = new Intl.NumberFormat('nb-NO', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
const currencyFormatterNoDecimals = new Intl.NumberFormat('nb-NO', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

/**
 * Gets the default quantity to use when buying a product.
 * @param product The product to get the default quantity for.
 * @param breakoff Whether breakoff is enabled.
 * @param defaultQuantity The default quantity to use if no other quantity is found. Defaults to 1.
 * @returns The default quantity to use for the product.
 */
export function getDefaultBuyQuantity(product: SimpleProduct, breakoff: boolean, defaultQuantity: number = 1): number {
    if (breakoff) {
        return 1 || defaultQuantity;
    }

    return product.Behavior?.MultipleOfQuantity || defaultQuantity;
}

export function formatCurrencyNOK(price: number | undefined, context?: ICoreContext, currencyCode: string = 'NOK', noDecimals?: boolean): string {
    if (price === undefined) {
        return '';
    }

    if (!context || currencyCode === 'NOK') {
        if (noDecimals) {
            return `${currencyFormatterNoDecimals.format(Math.trunc(price))} kr`;
        }

        return `${currencyFormatter.format(price)} kr`;
    } else {
        return context.cultureFormatter.formatCurrency(price, currencyCode);
    }
}
